(function (angular) {
	angular.module('bizPartEngage').service('core.terms.service', termsService);

	termsService.$inject = ["$http"];

	function termsService($http) {
		this.GetSystemTerms = function (unitId) {
			return $http.get(siteRootPath + 'api/Terms/GetSystemTerms', {
				params: {
					includeAccepted: true
				}
			});
		};
	}
})(window.angular);
